import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import SimpleTooltipText from '@wix/da-ds/pkg/tooltips/SimpleTooltipText';
import { ReverseTheme } from '@wix/da-react-context/pkg/ThemeContext';
import BasicTooltip from '../../../Popover/BasicTooltip';
import { useBasicPopoverPositioning } from '@wix/da-ds/pkg/popper/hooks/useBasicPopoverPositioning';
import { usePortalNode } from '@wix/da-ds/pkg/popper/hooks/usePortalNode';
import s from './ConditionalTooltip.scss';
/*
  These tooltips are special snowflakes and don't use popper
  Reason being that there is a million of them, so performance is an issue;
  also they always appear in a simple fixed position so we can calculate things
  easily with just plain js and no react updates
*/
var ConditionalTooltip = function (_a) {
    var showTooltip = _a.showTooltip, tooltipContent = _a.tooltipContent, children = _a.children;
    var portalContainer = usePortalNode('tooltip', s['tooltip-portal']);
    var _b = useState(null), contentNode = _b[0], setContentNode = _b[1];
    var _c = useState(null), tooltipNode = _c[0], setTooltipNode = _c[1];
    var positionTooltip = useBasicPopoverPositioning(contentNode, tooltipNode, {
        placement: 'right',
        enabled: showTooltip,
        updatePositionOnScroll: false,
    }).positionTooltip;
    useEffect(function () {
        if (!showTooltip || !contentNode || !tooltipNode) {
            return;
        }
        var displayTooltip = function () {
            positionTooltip();
            tooltipNode.classList.add(s['visible']);
        };
        var hideTooltip = function () {
            tooltipNode.classList.remove(s['visible']);
        };
        contentNode.addEventListener('mouseenter', displayTooltip);
        contentNode.addEventListener('mouseleave', hideTooltip);
        window.addEventListener('scroll', hideTooltip);
        return function () {
            contentNode.removeEventListener('mouseenter', displayTooltip);
            contentNode.removeEventListener('mouseleave', hideTooltip);
            window.removeEventListener('scroll', hideTooltip);
        };
    }, [contentNode, showTooltip, tooltipNode, positionTooltip]);
    if (showTooltip) {
        return (React.createElement("div", { className: s['tooltip-wrapper'], ref: setContentNode },
            children,
            portalContainer &&
                ReactDOM.createPortal(React.createElement(ReverseTheme, null,
                    React.createElement(BasicTooltip, { placement: "right", wrapperClassName: s['tooltip'], ref: setTooltipNode },
                        React.createElement(SimpleTooltipText, { className: s['tooltip-content'] }, tooltipContent))), portalContainer)));
    }
    return React.createElement("div", { className: s['tooltip-wrapper'] }, children);
};
ConditionalTooltip.displayName = 'ConditionalTooltip';
export default ConditionalTooltip;
//# sourceMappingURL=ConditionalTooltip.js.map